import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* Row spacing is carried by each row's own padding; zeroing the
         shared gap keeps the padding tracks exact too. */
      --block-row-gap: 0px;
      display: block;
      color: var(--block-text-color, #222);
    }

    /*
      Mobile: text on row 2, image on row 3, both spanning the 6-column grid.
      Vertical spacing is set with padding on the items, so the grid's mobile
      row gap is dropped to keep the math readable.
    */
    .mike-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    .text-column {
      grid-column: 2 / 8;
      grid-row: 2;
      display: flex;
      flex-direction: column;
      max-width: calc(604rem / var(--default-rem-px-count));
      gap: calc(40rem / var(--default-rem-px-count));
    }

    .text-block {
      display: flex;
      flex-direction: column;
      gap: calc(30rem / var(--default-rem-px-count));
    }

    /* Eyebrow is a p, but pinned to Body Small so it stays 14px on desktop. */
    .eyebrow {
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      font-weight: var(--fw-regular);
      margin: 0;
    }

    .image-column {
      grid-column: 2 / 8;
      grid-row: 3;
      padding-top: calc(50rem / var(--default-rem-px-count));
    }

    .image-holder {
      width: 100%;
      background-color: #ececec;
      overflow: hidden;
      display: flex;
      min-height: calc(251rem / var(--default-rem-px-count));
    }

    .image-holder img {
      width: 100%;
      height: auto;
      display: block;
    }

    @media (min-width: 600px) {
      /* Tablet: still stacked, but across the 12-column grid. */
      .text-column {
        grid-column: 2 / 14;
        gap: calc(60rem / var(--default-rem-px-count));
      }

      .text-block {
        gap: calc(40rem / var(--default-rem-px-count));
      }

      .image-column {
        grid-column: 2 / 14;
        padding-top: calc(60rem / var(--default-rem-px-count));
      }

      .image-holder {
        min-height: calc(500rem / var(--default-rem-px-count));
      }
    }

    @media (min-width: 1024px) {
      /*
        Desktop: text takes four columns and the image the remaining eight, on
        one row. The space between them is the grid gutter, not a fixed gap.
        The eyebrow sits at the top of the text column and the header block is
        pushed to the bottom so both columns read as one full-height band.
      */
      .mike-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .text-column {
        grid-column: 2 / 6;
        grid-row: 2;
        max-width: none;
        justify-content: space-between;
      }

      .image-column {
        grid-column: 6 / 14;
        grid-row: 2;
        padding-top: 0;
        display: flex;
      }

      .image-holder {
        align-self: stretch;
        min-height: calc(550rem / var(--default-rem-px-count));
      }
    }
  `,
];
